// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 642 ? "94a7ad86" : chunkId) + "." + {"203":"3c2eefe7a2a47f7c","544":"72ba26019dc71578","642":"84f6aadf61adf541"}[chunkId] + ".js";
};